

export class License {

  impactPlusReportCredits: number = 0;

  impactPlusReportRefreshCredits: number = 0;

  riskPlusReportCredits: number = 0;

  riskPlusReportRefreshCredits: number = 0;

  controlPlusReportCredits: number = 0;

  controlPlusReportRefreshCredits: number = 0;

  platformAccessUntil: string = "";

  licenseTier: string = "";

  constructor(init?: Partial<License>) {
    Object.assign(this, init);
  }

}

